export default "__VITE_ASSET__KpP1P_aW__"